"use client";

import { IStoryBlokComponent } from "apps/website/components/page/api.types";

import SectionKlaviyoForm from "../../section/SectionKlaviyoForm/SectionKlaviyoForm";
import {
  TKlaviyoFormModalPopupOn,
} from "../../section/SectionKlaviyoForm/SectionKlaviyoForm.types";

type TStoryBlokKlaviyoFormType = "SECTION" | "MODAL";

interface IBaseStoryBlokKlaviyoForm {
  form_id: string;
  display_type: TStoryBlokKlaviyoFormType;
  feature_flag_id?: string;
  feature_flag_value?: string;
}

interface IStoryBlokKlaviyoFormModal extends IBaseStoryBlokKlaviyoForm {
  display_type: "MODAL";
  delay?: number;
  popup_on?: TKlaviyoFormModalPopupOn;
  days_until_can_show_again?: number;
}

interface IStoryBlokKlaviyoFormSection extends IBaseStoryBlokKlaviyoForm {
  display_type: "SECTION";
}

type TStoryBlokKlaviyoForm = IStoryBlokKlaviyoFormModal | IStoryBlokKlaviyoFormSection;

const isStoryBlokModalKlaviyoForm = (form: TStoryBlokKlaviyoForm): form is IStoryBlokKlaviyoFormModal => form.display_type === "MODAL";

export const StoryBlokKlaviyoForm = ({ blok }: IStoryBlokComponent<TStoryBlokKlaviyoForm>) => (
  <SectionKlaviyoForm
    formId={blok.form_id}
    displayType={blok.display_type}
    featureFlagId={ blok.feature_flag_id }
    featureFlagValue={ blok.feature_flag_value }
    delay={ isStoryBlokModalKlaviyoForm(blok) ? blok.delay : undefined}
    popupOn={ isStoryBlokModalKlaviyoForm(blok) ? blok.popup_on : undefined }
    daysUntilCanShowAgain={ isStoryBlokModalKlaviyoForm(blok) ? blok.days_until_can_show_again : undefined }
  />
);
